import { AnalyticsService } from './services/analytics.service';
import { SeoService } from './services/seo.service';
import { NbThemeService } from '@nebular/theme';
import { Component, OnInit } from '@angular/core';
import { HelpService } from './services/help.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, take } from 'rxjs/operators';
import { ExclusivesCartService } from './exclusives/exclusives.cart.service';
import { ShopService } from './shop/shop.service';

declare var snowStorm: any;
declare var NiceJob: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'retail';
  theme = 'default';

  constructor(
    public themeService: NbThemeService,
    private seoSvc: SeoService,
    private analyticsSvc: AnalyticsService,
    private spinner: NgxSpinnerService, // needed for import
    private helpService: HelpService,
    private exclusivesCart: ExclusivesCartService,
    private shopService: ShopService
  ) {
    this.seoSvc.initSEO();
  }

  async ngOnInit(): Promise<void> {
    // Fire-and-forget: hydrate the exclusives cart from localStorage if present.
    // Non-blocking — badge updates from 0 to N when the HTTP resolves.
    // Gated by isExclusivesEnabled so we don't hit the dropship API when the
    // feature is off. Waits for the first emission where the flag is true
    // (skipping the conservative seed) so the gate is honored in production.
    this.shopService
      .shopSettings$()
      .pipe(
        filter((s) => !!s.isExclusivesEnabled),
        take(1)
      )
      .subscribe(() => this.exclusivesCart.hydrate());
    try {
      await this.analyticsSvc.enable();
      this.theme = (await this.helpService.getRemoteConfigData('theme')) || 'default';
      this.themeService.changeTheme(this.theme);
      if (this.theme === 'fall') {
        this.helpService.themeGalleryURL = '/gallery/collection/seasonal/category/seasonal-fall';
        this.helpService.themeItems = ['Pumpkins', 'Mums', 'Hay Bales', 'Corn Stalks'];
      } else if (this.theme === 'winter') {
        this.helpService.themeGalleryURL = '/gallery/collection/seasonal/category/seasonal-winter';
        this.helpService.themeItems = [
          `Fraser Fir`,
          `Douglas Fir`,
          `Concolor Fir`,
          `Scotch Pine`,
          `Colorado Spruce`,
          `Tree Stands`,
          `Tree Skirts`,
          `Easy Clean Tree Bags`,
          `Live Wreaths`,
          `Wreath Services`,
          `Custom Wreaths`,
          `Christmas Lights`,
          `Fraser Roping`,
          `White Pine Roping`,
          `Christmas Ornaments`,
          `Festive Stockings`
        ];
      }
    } catch (error) {
      console.error('Error starting: ', error);
    }
  }
}
